import React, {useEffect, useState} from 'react'
import {Button, Grid, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useLanguage} from "../LanguageContext";
import {useIntl} from "react-intl";
import {Link, useParams} from "react-router-dom";
import axios from "axios";
import {getPrefix} from "../global_func";

const PageItem = () => {

    let { id } = useParams();
    const [page, setPage] = useState(null)

    useEffect(function (){
        fetch("https://api.altynlogistics.com/api/page/" + id)
            .then(res => res.json())
            .then(p => {
                setPage(p)
            })
    }, [])



    const {locale, changeLocale} = useLanguage();

    // console.log(locale)

    const intl = useIntl();


    const theme = useTheme()
    const isXs = useMediaQuery(theme.breakpoints.down('xs'));
    const isMd = useMediaQuery(theme.breakpoints.up('md'));

    let variant = 'h3'

    let secondVariant = 'subtitle2'

    if (isXs) {
        variant = 'h3';
        secondVariant = 'subtitle2'
    } else if (isMd) {
        variant = 'h2';
        secondVariant = 'subtitle1'
    }


    const pic1 = () => {

        if (page && page.pic_1 === 1) {
            return <div className={"hover-info"}>
                <img style={{
                    width: "100%",
                    // height: "100%",
                    padding: '10px',
                    border: '1px solid #eee',
                    borderRadius: '8px',
                    boxShadow: '5px solid #aaa'
                }} src={"https://api.altynlogistics.com/images/pages/" + page.id + "/1.png"}
                     alt={''}/>
                <div>
                    <div style={{}}>
                        <img style={{width: '12px', margin: 'auto 8px'}} src={"/assets/Images/icon_call.svg"}/>

                        {page.meta_1}</div>
                    <div style={{position:'relative', }}>
                        <img style={{width: '12px', margin: 'auto 8px'}} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAABEElEQVR4nO3UPS9EQRTG8Z+XiEQoVBL7YSRaKjodHZ3GV1Aolbai0+lU2i1pVHyA/QLeWVk5Jte1V3bYVWzuPzm5c2fOPM/N3DmHmppRZgGX6AwprtEomy7Hcx6tIZi2Qrvo9cEj1mM8g/MBml5gLrRXcV807ia8YDPep3A6ANMzTIfmBp5j/otxN96wG3MTOPqD6TEmQ2sHr4W1b8afsR/zYzj4hekhxkNjr8d6pXE/m6uin49OVImcFI5ru3Rc5Sj/puYPuYmcC/LUIyf3Yib6KYnZyF3BXWHtAWuZpZjIbQJLuMVNjHObTyKn7S3q3W6vMnQSOaXSxlb03UaM25kaic4/R6I27oz8UdfUjA7vZuyuMsipCFsAAAAASUVORK5CYII="/>

                            {page.meta_2}
                    </div>
                </div>

            </div>
        }

        return <></>
    }
    const pic2 = () => {

        if (page && page.pic_2 === 1) {
            return <div>
            <img style={{
                    width: "100%",
                    // height: "100%",
                    padding: '10px',
                    border: '1px solid #eee',
                    borderRadius: '8px',
                    boxShadow: '5px solid #aaa'
                }} src={"https://api.altynlogistics.com/images/pages/" + page.id + "/2.png"}
                     alt={''}/>
            </div>
        }

        return <></>
    }

    return (

        page &&
        <Grid dir={locale === 'fa' ? 'rtl' : 'ltr'}>

            <Grid bgcolor={'rgba(255, 251, 242, 1)'} px={{xs: '18px', xxs: '27px', md: '75px', lg: '103px'}}
                  pt={{xs: '145px', md: '176px'}} position="relative" zIndex={2}>
                <Grid sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: -10,
                    backgroundImage: {
                        xs: 'url(assets/images/MobileAboutUsBackGround.svg)',
                        md: 'url(assets/images/BackAboutUs.svg)'
                    },
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}>
                </Grid>
                <Grid border={'2px solid rgba(255, 191, 63, 1)'} borderRadius={'20px'} bgcolor={'white'}
                      px={{xs: '12px', xxs: '16px', md: '64px'}} pt={{xs: '24px', md: '32px'}}
                      pb={{xs: '36px', md: '64px'}} mb={{xs: '24px', md: '64px'}}>
                    <Typography pb={'16px'} variant={variant} fontWeight={900} color={theme.palette.secondary.one}>
                        { page['title'+ getPrefix(locale)]}
                    </Typography>
                    <hr />
                    <Typography textAlign={'justify'} variant={secondVariant} fontWeight={500}
                                color={theme.palette.secondary.one}>

                        { page && (page.pic_1 === 1 || page.pic_2 === 1) &&
                            <div style={{display: "flex", padding:'10px'}}>
                                { pic1() }
                                <div style={{padding:'5px'}}>&nbsp;</div>
                                { pic2() }
                            </div>
                        }

                        <div dangerouslySetInnerHTML={{__html: page['content' + getPrefix(locale)]}}/>

                    </Typography>


                </Grid>
            </Grid>
        </Grid>
    )
}
export default PageItem
